<template>
  <div class="sl-all-card-style ">

<!--    左边的GIF图和上面设备按钮-->
    <div class="sl-left-all-box" >

<!--      按钮盒子-->
      <div class="sl-button-all-box">

        <div class="sl-button-single-box">
          <img src="../../../dataplayimg/icon1.png" alt="" class="sl-button-icon-img">
          <div>出水口</div>
        </div>

        <div class="sl-button-single-box">
          <img src="../../../dataplayimg/icon2.png" alt="" class="sl-button-icon-img">
          <div>水泵</div>
        </div>

        <div class="sl-button-single-box">
          <img src="../../../dataplayimg/icon3.png" alt="" class="sl-button-icon-img">
          <div>水泵-1</div>
        </div>
        <div class="sl-button-single-box">
          <img src="../../../dataplayimg/icon4.png" alt="" class="sl-button-icon-img">
          <div>氧气传感器</div>
        </div>

        <div class="sl-button-single-box">
          <img src="../../../dataplayimg/icon5.png" alt="" class="sl-button-icon-img">
          <div>uv过滤器</div>
        </div>

        <div class="sl-button-single-box">
          <img src="../../../dataplayimg/icon6.png" alt="" class="sl-button-icon-img">
          <div>机械过滤器</div>
        </div>
        <div class="sl-button-single-box">
          <img src="../../../dataplayimg/icon7.png" alt="" class="sl-button-icon-img">
          <div>氧气锥</div>
        </div>
         <div class="sl-button-single-box">
          <img src="../../../dataplayimg/icon1.png" alt="" class="sl-button-icon-img">
          <div>氧气锥</div>
        </div>
      </div>

<!--      GIF图盒子-->
      <div class="sl-gif-all-box" style="margin: 20px;">
        <img src="../../../img/smap1.png" alt="" style="position: absolute;  top: 75px;    left: 15px;    width: 80%;"
             v-show="mapData.mapData.iTypeID==1" >

        <img src="../../../img/1/bw.gif" alt="" style="position: absolute;  top: 75px;    left: 15px;    width: 80%;"
             v-show="mapData.mapData.iTypeID==1" >

        <img src="../../../img/1/gfj.gif" alt="" style="position: absolute;  top: 75px;    left: 15px;    width: 80%;"
             v-show="mapData.mapData.iTypeID==1&&mapData.mapData.kg1>0" >

        <img src="../../../img/1/glq.gif" alt="" style="position: absolute;  top: 75px;    left: 15px;    width: 80%;"
             v-show="mapData.mapData.iTypeID==1&&mapData.mapData.kg2>0">

        <img src="../../../img/1/sb.gif" alt="" style="position: absolute;  top: 75px;    left: 15px;    width: 80%;"
             v-show="mapData.mapData.iTypeID==1&&mapData.mapData.kg3>0">
        <img src="../../../img/1/zwx.gif" alt="" style="position: absolute;  top: 75px;    left: 15px;    width: 80%;"
             v-show="mapData.mapData.iTypeID==1&&mapData.mapData.kg5>0">
      </div>

        <div class="sl-gif-all-box" style="">
        <img src="../../../img/smap2.png" alt="" style="position: absolute;margin-top: -14px;margin-left: -148px;width:98%;"
             v-show="mapData.mapData.iTypeID==2" >


        <img src="../../../img/2/sb1.gif" alt="" style="position: absolute;margin-top: -14px;margin-left: -148px;width:98%;"
             v-show="mapData.mapData.iTypeID==2&&mapData.mapData.kg1>0" >
        <img src="../../../img/2/sb2.gif" alt="" style="position: absolute;margin-top: -14px;margin-left: -148px;width:98%;"
             v-show="mapData.mapData.iTypeID==2&&mapData.mapData.kg2>0" >
        <img src="../../../img/2/sb3.gif" alt="" style="position: absolute;margin-top: -14px;margin-left: -148px;width:98%;"
             v-show="mapData.mapData.iTypeID==2&&mapData.mapData.kg3>0" >
        <img src="../../../img/2/sb4.gif" alt="" style="position: absolute;margin-top: -14px;margin-left: -148px;width:98%;"
             v-show="mapData.mapData.iTypeID==2&&mapData.mapData.kg5>0" >
      </div>

      <div class="sl-gif-all-box" style="">
        <img src="../../../img/smap3.png" alt="" style="position: absolute;margin-top: -14px;margin-left: -100px;width:98%;"
             v-show="mapData.mapData.iTypeID==3" >


        <img src="../../../img/3/sbsy.gif" alt="" style="position: absolute;margin-top: -14px;margin-left: -100px;width:98%;"
             v-show="mapData.mapData.iTypeID==3&&mapData.mapData.kg1>0" >
        <img src="../../../img/3/sh.gif" alt="" style="position: absolute;margin-top: -14px;margin-left: -100px;width:98%;"
             v-show="mapData.mapData.iTypeID==3" >
      </div>

    </div>


<!--    右边设备详情-->
  <div class="sl-shebei-all-box">
<!--    <img src="../../../img/sceneList/shebeikuang.png" alt="" width="100%">-->



<!--    <div class="sl-shebei-title-text">-->
<!--      机械过滤器-->
<!--    </div>-->

    <!--传感器数据-->
    <div class="sl-cgq-all-box">
      <div class="sl-cgq-title-box"><img src="../../../dataplayimg/q.png" alt="" style="width: 15px;margin-right: 10px">数据展示</div>
      <div class="sl-cgq-content-box"  style="padding-left:10px;">
        <!-- <div v-for="(item,index) in propertiesR" :key="index" class="sl-cgq-single-box">
          {{item.name}}:{{item.dataValue}}
        </div> -->




          <div class="sl-cgq-single-box" v-for="(item,index) in mapData.propertiesR" :key="index" style="justify-content:left;">
            <div>•</div>
            <div class="name">        {{item.name}}</div>
            <div>：</div>
            <div class="dataValue">{{item.dataValue}}</div>
            <div class="dan"></div>

        </div>

      </div>
    </div>


    <!--执行器数据-->
    <div class="sl-zxq-all-box">
      <div class="sl-cgq-title-box"><img src="../../../dataplayimg/l.png" alt="" style="width: 15px;margin-right: 10px">设备控制</div>
      <div class="sl-cgq-content-box" style="padding-left:10px;">
        <!-- <div v-for="(item,index) in propertiesW" :key="index" class="sl-cgq-single-box">
          {{item.name}}:
          <img @click="deviceControl(this,item)" :src="item.icon" alt="" width="60px">
          <img src="../../../dataplayimg/guan.png" >
        </div> -->
        <div  class="sl-cgq-single-box" v-for="(item,index) in mapData.propertiesW" :key="index" style="justify-content:left;">
          {{item.name}}
            <img  @click="deviceControl(this,item)" :src="item.icon"  class="guan">
        </div>







      </div>
    </div>

  </div>

  </div>
</template>


<script>
  // @ is an alias to /src
  import TitleCard from '@/components/TitleCard.vue'
  import { _getDevicePropDataTop } from '@/common/request'

  export default {
    name: 'senceList2',
    components: {
      TitleCard
    },
    data() {
      return {
        titleMsg1: "设备管理",
        titleMsg2:'场地列表',
        titleMsg3:'场地列表',
        deviceData:{},
        propertiesR:[],
        propertiesW:[],
        queryInfo:{
          sceneId:'',
          cEntID:''

        },
        setDeviceProParam:{},
        productKeys:[],
        mapData:[],
        timer:''

      }
    }
    ,mounted () {
      let that=this;
      that.queryInfo.cEntID=that.$store.getters.User.enterprise.ID;

      that.queryInfo.sceneId=that.$store.getters.SCene.ID;

    //  console.log('A'+that.queryInfo.sceneId+'1');
      that.$bus.$on('scenechange',(target)=> {
        that.queryInfo.sceneId=target.id;
  //      console.log('C'+that.queryInfo.sceneId+'1');
        that.getDevice();
      });
      that.timer=setInterval(that.getDevice,10000)

      that.getDevice();
    },
    methods:{
      //开关控制
      async deviceControl(obj,item){
let that=this;
        var param='"'+item.identifier+'":'+(item.dataValue==0?1:0);

        this.setDeviceProParam.productKey= item.productKey
        this.setDeviceProParam.devicename= item.deviceName
        this.setDeviceProParam.iotId=item.iotId
        this.setDeviceProParam.inputParam='{'+param+'}'

        let res =await this.$http.post('WLWDevice/SetDeviceProperty',this.setDeviceProParam)
console.log('item123123123',item);
        if(res.data.code=="200"){
      //   that.getDevice();

          if(this.mapData.mapData.zxq1==item.ID)this.mapData.mapData.kg1=item.dataValue==0?1:0;
          if(this.mapData.mapData.zxq2==item.ID)this.mapData.mapData.kg2=item.dataValue==0?1:0;
          if(this.mapData.mapData.zxq3==item.ID)this.mapData.mapData.kg3=item.dataValue==0?1:0;
          if(this.mapData.mapData.zxq4==item.ID)this.mapData.mapData.kg4=item.dataValue==0?1:0;
          if(this.mapData.mapData.zxq5==item.ID)this.mapData.mapData.kg5=item.dataValue==0?1:0;
          if(this.mapData.mapData.zxq6==item.ID)this.mapData.mapData.kg6=item.dataValue==0?1:0;
          if(this.mapData.mapData.zxq7==item.ID)this.mapData.mapData.kg7=item.dataValue==0?1:0;




          this.$message.success(res.data.message)
          if (item.dataValue>=1){
            item.icon=require('../../../img/openIcon.png')

          }
          else {
            item.icon=require('../../../img/closeIcon.png')
          }
        }
        else{
          this.$message.error(res.data.message)
        }

      },
      async getDevice(){


   let that=this;


   let res = await that.$http.post('WLWDevice/SelBySceneId', {
     sceneId: that.queryInfo.sceneId,
     cEntID: that.queryInfo.cEntID
   })
console.log('res:::::::::::::::::',res);
   that. mapData=res.data.obj;


   var data =await _getDevicePropDataTop(this, {
     productkey:   that. mapData.deviceData.ProductKey,
     devicename: that.mapData.deviceData.DeviceName
   })
   console.log('data:::::::::::::::::',data);
   var dataItems ={};
   data.obj.list.forEach((ele,index)=>{
     for (let i in ele.dataItems){
       that.$set(ele.dataItems[i], "deviceName", ele.deviceName)
       that.$set(ele.dataItems[i], "productKey", ele.productKey)
       that.$set(ele.dataItems[i], "iotId", ele.iotId)
       that.$set(dataItems,i,ele.dataItems[i])
     }
   })
   that.mapData.propertiesR.forEach(element => {
     if (dataItems[element.identifier] != null) {
if(typeof(element.dataSpecs)=='string'){
  console.log('element.dataSpecs',typeof(element.dataSpecs));
  let unitJson=JSON.parse(element.dataSpecs)

  that.$set(element,"dataSpecs",unitJson);

  that.$set(element,"unit",unitJson.unit);

}
     //  console.log('elemen unitt:::',unitJson.unit);
       var value = that.utils.formatPropData(element, dataItems[element.identifier].value)
   //    console.log('value:::',value);
       that.$set(element, "dataValue", value)
     }else {
       that.$set(element, "dataValue", '')
     }
   })
   that.mapData.propertiesW.forEach(element => {

     if (dataItems[element.identifier]) {
       if(typeof(element.dataSpecs)=='string'){

         let unitJson=JSON.parse(element.dataSpecs)
         that.$set(element,"dataSpecs",unitJson);
         console.log('elementelementelement:::',element);

       }


       var value = that.utils.formatPropData(element, dataItems[element.identifier].value, false)
       console.log('value:::',dataItems[element.identifier].value,value);
       that.$set(element, "dataValue", value)
       that.$set(element, "iotId", dataItems[element.identifier].iotId)

       that.$set(element, "productKey", dataItems[element.identifier].productKey)
       that.$set(element, "deviceName", dataItems[element.identifier].deviceName)
     } else {
       that.$set(element, "dataValue", 0)
       that.$set(element, "productKey", '')
       that.$set(element, "deviceName", '')
       that.$set(element, "iotId", '')

     }

     if (value>=1){
       that.$set(element, "icon", require('../../../img/openIcon.png'))

     }
     else {
       that.$set(element, "icon", require('../../../img/closeIcon.png'))
     }
   })














      },

    },
    watch:{
      deviceData(old,newval){
        console.log(old)
        console.log(newval)
      }
    },
    beforeDestroy(){

      clearInterval(this.timer)
    }

  }
</script>



<style>
  @import "sceneList.css";
  .name{

    margin-left: 5px;
  }
  .dataValue{
      margin-left: 5px;
  }
  .guan{
      margin-left: 10px;
      height: 20px;
  }
</style>
